import { useMutation } from '@tanstack/react-query'

import { downloadAsZipRequest } from './request'

export const useDownloadAsZipMutation = () =>
  useMutation({ mutationFn: downloadAsZipRequest })
